import { pricingLineKey } from './pricingLineKey';

function quoteRateByKey(quote) {
  const map = new Map();
  (quote?.breakdown?.line_items || []).forEach(l => {
    if (l.is_discount) return;
    map.set(pricingLineKey(l), l);
  });
  return map;
}

function applyQuoteRateToLiveLine(liveLine, rateMap) {
  const quoted = rateMap.get(pricingLineKey(liveLine));
  const qty = Number(liveLine.quantity || 0);
  const unitPrice = Number(
    quoted != null ? quoted.unit_price : liveLine.unit_price || 0
  );
  let baseTotal = unitPrice * qty;
  let adjustment = null;
  let adjustmentAmount = 0;

  const adj = quoted?.adjustment;
  if (adj && Number(adj.value || 0) > 0) {
    const value = Number(adj.value || 0);
    adjustmentAmount =
      adj.type === 'percent' ? baseTotal * (value / 100.0) : value;
    adjustmentAmount = Math.round(adjustmentAmount * 100) / 100;
    adjustment = adj;
    baseTotal += adjustmentAmount;
  }

  const lineTotal = Math.max(baseTotal, 0);
  return {
    ...liveLine,
    unit_price: unitPrice,
    line_total: Math.round(lineTotal * 100) / 100,
    adjustment,
    adjustment_amount: adjustmentAmount,
    quoted_rate: !!quoted,
  };
}

/**
 * Suggested price: current event quantities × rates from the given quote
 * (or plan rates when no quote / no matching line).
 * Quote document discounts and line-item discounts are not applied.
 * @returns {{ total: number|null, rows: Array, discount: number, subtotal: number }}
 */
export function computeSuggestedPricing(breakdown, quote = null) {
  if (!breakdown) {
    return { total: null, rows: [], discount: 0, subtotal: 0, discounts: [] };
  }

  const rateMap = quoteRateByKey(quote);
  const rows = (breakdown.line_items || [])
    .filter(l => !l.is_discount)
    .map(l => {
      const priced = applyQuoteRateToLiveLine(l, rateMap);
      return {
        key: pricingLineKey(l),
        name: priced.name,
        live: priced,
        quoted: null,
      };
    });

  const subtotal = rows.reduce(
    (sum, row) => sum + Number(row.live?.line_total || 0),
    0
  );
  const total = Math.round(subtotal * 100) / 100;

  return { total, rows, discount: 0, subtotal, discounts: [] };
}

export function suggestedRateQuote(acceptedQuote, compareQuote) {
  return acceptedQuote || compareQuote || null;
}
